import { AvailabilityRating } from "./enums/AvailabilityRating.enum";
import { ConfidentialityRating } from "./enums/ConfidentialityRating.enum";
import { DataIntegrityRating } from "./enums/DataIntegrityRating.enum";
import { IdmApplicationOwnerType } from "./enums/IdmApplicationOwnerType.enum";


export interface IIdmApplicationOwner {
    ownerType: IdmApplicationOwnerType
    id: string
    mail: string
    displayName: string
}


/**
 * API interface for
 *   GET: /api/chevronapplications
 *   GET: /api/chevronapplications/{id}
 */
export interface IIdmApplication {
    serviceId: string,
    displayName: string,
    isActive: boolean,
    availabilityRating: AvailabilityRating,
    confidentialityRating: ConfidentialityRating,
    dataIntegrityRating: DataIntegrityRating,
    environments: string[],
    associatedAzureSubscriptionIds: string[],
    owners: IIdmApplicationOwner[]
}

/**
 * API model for
 *   GET: /api/chevronapplications
 *   GET: /api/chevronapplications/{id}
 */
export class IdmApplication implements IIdmApplication {
    serviceId: string = '';
    displayName: string = '';
    isActive: boolean = false;
    availabilityRating: AvailabilityRating = AvailabilityRating.Tier1;
    confidentialityRating: ConfidentialityRating = ConfidentialityRating.Tier1;
    dataIntegrityRating: DataIntegrityRating = DataIntegrityRating.Tier1;
    environments: string[] = [];
    associatedAzureSubscriptionIds: string[];
    owners: IIdmApplicationOwner[];
}

// this model is used for displaying the application environment options
export class EnvironmentOption {
    value: string = '';
    environmentName: string = '';
}